import { IsAlphanumeric, IsOptional, Matches, MaxLength, IsNotEmpty } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";

export class EducationDTO{
     @ApiProperty()
     @IsNotEmpty({message: 'Education Id should not be empty'})
     @IsAlphanumeric()
     @IsOptional()
     educationId: number;

     @ApiProperty()
     @IsNotEmpty({message: 'Education name should not be empty'})
     education: string;

     @ApiProperty()
     isActive: boolean;

     createdAt: Date;

     @ApiProperty()
     @IsOptional()
     @MaxLength(40, {message: 'Created user allows maximum 40 characters'})
     @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: 'Created User should be only alphabets'})
     createdUser: string;

     updatedAt: Date;

     @ApiProperty()
     @IsOptional()
     @MaxLength(40, {message: 'Updated user allows maximum 40 characters'})
     @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: 'Updated user should be only characters'})
     updatedUser: string;

     @ApiProperty()
     versionFlag: number;
}